import { injectTranslate } from '@core/i18n-legacy';
import { textCellFactory } from '@core/user-interface-legacy';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../offer-columns';

export const departmentColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.Department,
  label: injectTranslate()('app.offers.table.department'),
  visible: true,
  geometry: {
    width: 110,
    minWidth: 110,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: textCellFactory('department'),
}));
